const PAYMENTS_QUERY_STALE_TIME = 10 * 60 * 1000; // 10 minutes

export { PAYMENTS_QUERY_STALE_TIME };

export enum CognitoGroups {
  SPLADMINS = 'Spladmins',
  VIP = 'vip',
}
